import request from '@/shared/api/request';

import type { DatabaseFirewallRule } from '../../types';

export const getDatabaseFirewallRules = (
  database_uuid: string,
): Promise<{ rules: DatabaseFirewallRule[] }> =>
  request({
    url: `/databases/${database_uuid}/firewall/`,
  });
